/* export
  - menuIdRouteMappings
  - menuIdNameMappingsFromBundle
*/;

export * from 'sce-core/constants';
// #TODO-LIBRARY constants->menuIdRouteMappings Used in 13 places 13 files in WMS /src/app.. should be re-referenced from library directly



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/constants.ts